import React, { ReactElement, useEffect } from 'react';
import { Loader } from 'idsk-react-components';
import { useParams } from 'react-router';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import routes from '../../../routing/routes';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import OdmietnutieGestora from '../../../module/PracovnyKrok/OdmietnutieGestora';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import PracovnyKrokEnum from '../../../model/pracovnyKrok/PracovnyKrokEnum';
import SuccessMessages from '../../../module/SuccessMessages';

const OdmietnutieGestoraPage = (): ReactElement => {
  const {
    type,
    year,
    index,
    pracovnyKrokId,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.ODMIETNUT_GESTORA);

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.procesy.list,
          heading: 'Legislatívne procesy',
        },
        {
          to: routes.procesy.detail.withParams(type, year, index),
          heading: `${type}/${year}/${index}`,
        },
        {
          to: routes.procesy.gestor.odmietnutie.withParams(type, year, index, pracovnyKrokId),
          heading: 'Odmietnutie gestora',
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          additionalCheck={materialDetail?.hasPracovnyKrokInZasobnikPrace}
          hasOpravneniePracovneKroky={materialDetail?.hasOpravneniePracovneKroky}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  heading="Odmietnutie gestora"
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                />
                <OdmietnutieGestora />
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default OdmietnutieGestoraPage;
